"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = require("react");
var _reactHotLoader = require("react-hot-loader");
var _excluded = ["rhl", "children"];
var AppContainer = function AppContainer(_ref) {
  var rhl = _ref.rhl,
    children = _ref.children,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return rhl ? /*#__PURE__*/(0, _react.createElement)(_reactHotLoader.AppContainer, props, children) : children;
};
AppContainer.defaultProps = {
  rhl: true
};
var _default = exports.default = AppContainer;